<template>
  <div class="vue-bulma">
    <!-- Modal -->
    <div class="modal" :class="{ 'is-active': showModal }">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Bulma Modal</p>
          <button class="delete" aria-label="close" @click="closeModal"></button>
        </header>
        <section class="modal-card-body" style="background: white;">
          <p>This modal appears when you press the "G" key.</p>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-primary" @click="closeModal">Close</button>
        </footer>
      </div>
    </div>
    <!-- /Modal -->
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

const showModal = ref(false)

function handleKeydown(e) {
  if (e.key === 'G') {
    showModal.value = true
  }
}

function closeModal() {
  showModal.value = false
}

onMounted(() => {
  window.addEventListener('keydown', handleKeydown)
})

onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleKeydown)
})
</script>

<style scoped>
p { color: purple; }
</style>
